var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"industry_module"},[_c('industry',_vm._g({attrs:{"lists":_vm.$attrs.lists,"total":_vm.$attrs.total}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }